import { useNgSession } from '../ng-session';
import { AxiosInstance, InternalAxiosRequestConfig, AxiosRequestHeaders } from "axios";

const { session } = useNgSession();

const playerIdInterceptor = (config: InternalAxiosRequestConfig) => {
    // https://github.com/axios/axios/issues/5573#issuecomment-1644862647
    config.headers ??= {} as AxiosRequestHeaders;
    try {
        config.headers["X-PLAYER-ID"] = session.value.PlayerID;
    } catch {}

    return config;
};

export const addPlayerIdInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(playerIdInterceptor, null, { synchronous: true });
};
